import TimeIcon from '@mui/icons-material/DateRange';
import { Collapse } from '@mui/material';
import { DateInput, FilterList } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import useDashboardContext from '../../hooks/useDashboardContext';
import dayjs from 'dayjs';
import { normalizeDateRange } from '../../lib/normalizeDateRange';

// dayjs('').toISOString() lança RangeError: limpar o campo de data derrubava o parse
const toIso = (value) => (value ? dayjs(value).toISOString() : value);

const DashboardIntervalPicker = ({ isOpen }) => {
  const { from, setFrom, to, setTo } = useDashboardContext();
  const { setValue } = useFormContext();

  // Os min/max do input de data são só dica de HTML: digitar De > Até mandava to < from pro
  // backend (400). Empurra o outro campo, no contexto (que dispara as queries) e no form (que mostra).
  const onFromChange = (date) => {
    if (!date.target.value) return;
    const next = normalizeDateRange({ from: dayjs(date.target.value).startOf('day').toISOString(), to }, 'from');
    setFrom(next.from);
    if (next.to !== to) {
      setTo(next.to);
      setValue('to', next.to);
    }
  };

  const onToChange = (date) => {
    if (!date.target.value) return;
    const next = normalizeDateRange({ from, to: dayjs(date.target.value).endOf('day').toISOString() }, 'to');
    setTo(next.to);
    if (next.from !== from) {
      setFrom(next.from);
      setValue('from', next.from);
    }
  };

  return (
    <>
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <FilterList
          label="Intervalo"
          icon={<TimeIcon titleAccess="Intervalo" />}
        />
      </Collapse>
      <DateInput
        label='De'
        source="from"
        ampm={false}
        parse={toIso}
        defaultValue={dayjs().startOf('day').subtract(1, 'month').toISOString()}
        onChange={onFromChange}
        inputProps={{
          max: dayjs(to).format("YYYY-MM-DD"),
        }}
        sx={{ minWidth: 160 }}
      />
      <DateInput
        label='Até'
        source="to"
        ampm={false}
        parse={toIso}
        defaultValue={dayjs().endOf('day').toISOString()}
        onChange={onToChange}
        inputProps={{
          min: dayjs(from).format("YYYY-MM-DD"),
          max: dayjs().format("YYYY-MM-DD"),
        }}
        sx={{ minWidth: 160 }}
      />
    </>
  );
}

export default DashboardIntervalPicker;
